import script from "./search-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-bar.vue?vue&type=script&setup=true&lang=ts"

import "./search-bar.vue?vue&type=style&index=0&id=4ebd5680&lang=scss&scoped=true"

import exportComponent from "D:\\work\\T\\jjxliu306\\demo\\search-bar\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ebd5680"]])

export default __exports__